import './Features.scss';
import imgDatabase from '../../images/icons/database-cloud-circle.png';
import imgPlay from '../../images/icons/play-circle.png';
import imgPdf from '../../images/icons/file-pdf.png';
import imgMobile from '../../images/icons/smartphone.png';
import imgPaint from '../../images/icons/paint.png';
import imgDiagram from '../../images/icons/diagram.png';
import imgSolution from '../../images/icons/solution.png';
import imgSolution2 from '../../images/icons/solution2.png';

const Features = () => {
  return (
    <section id="features" className="features section">
      <div className="container">
        <header className="header">
          <h2 className="title">
            <span className="title-accent">핵심</span> 주요 기능
          </h2>
          <p className="subtitle">매쓰테일러가 제공하는 강력한 솔루션</p>
          <p className="discontinued-note">
            - BASIC PDF를 HWP 변환 서비스(30원/페이지)는 서비스가 종료되었습니다.
          </p>
          {/* <div className="description">
            <p>아래한 기반 디비구축의 독보적인 기술력을 가진 매쓰오토젠<span className='italic'>!</span></p>
            <p>방대한 기능의 집합체, 만물 백화점처럼 없는게 없는 문제은행 솔루션<span className='italic'>!</span></p>
            <p>정기 업데이트를 통해 더욱 강력하게 진화하면서 정확한 DB 구축을 지원합니다<span className='italic'>!</span></p>
          </div> */}
          {/* <div className="notice">
            <p>개발자가 개발에 전념하느라 사이트에 모든 내용을 담지 못한 점 양해 바랍니다.</p>
            <p>문의를 통해서 필요한 기능이 과연 없는지 확인해주세요.</p>
              <p>준비되어있는 선생님 처럼 준비된 개발자이기 때문에 자신있습니다.</p>
          </div> */}
          
        </header>

        <div className="grid">
          <article className="card card--pro">
            <span className="badge badge--pro">PRO</span>
            <div className="icon">
              <img src={imgDatabase} alt="PDF PRO" />
            </div>
            <h3 className="card-title">PDF를 HWP로 변환</h3>
            <p className="card-description">가입비 0원 · 사용 기간 제한 없음</p>
            <p className="card-description">빠른 변환 속도 및 고퀄의 결과물</p>
            <p className="card-description">낙서 시험지 고급 분석</p>
            <p className="card-description">띄어쓰기 자동 교정</p>
            <p className="card-description">다단 레이아웃 자동 구분</p>
            <p className="card-description">40원/페이지</p>
          </article>

          <article className="card card--bank">
            <span className="badge badge--bank">문제은행</span>
            <div className="icon">
              <img src={imgDatabase} alt="문제은행" />
            </div>
            <h3 className="card-title">나만의 문제은행 구축</h3>
            <p className="card-description">디비구축 (미주처리된 HWP)</p>
            <p className="card-description">단원관리 (단원별/학교별)</p>
            <p className="card-description">문제출제</p>
            <p className="card-description">출제된 시험지 저장</p>
            <p className="card-description">프린트 (HWP/PDF)</p>
            <p className="card-description">20원/문항(문풀답)</p>
          </article>

          <article className="card">
            <span className="badge">무료</span>
            <div className="icon">
              <img src={imgSolution} alt="Solution" />
            </div>
            <h3 className="card-title">수학 문제 풀이 AI</h3>
            <p className="card-description">수학 문제를 AI가 자동으로 정답 및 풀이를 제공합니다.</p>
            <p className="card-description">변환된 문제를 HWP로 다운로드하여 활용할 수 있습니다.</p>
          </article>

          <article className="card">
            <span className="badge">무료</span>
            <div className="icon">
              <img src={imgSolution2} alt="Solution 2" />
            </div>
            <h3 className="card-title">수학 문제 변형 AI</h3>
            <p className="card-description">수학 문제를 변환해서 쌍둥이 문제를 만들 수 있습니다.</p>
            <p className="card-description">변환된 문제를 HWP로 다운로드하여 활용할 수 있습니다.</p>
          </article>

          <article className="card">
            <span className="badge">무료</span>
            <div className="icon">
              <img src={imgDiagram} alt="Diagram" />
            </div>
            <h3 className="card-title">수학 도형 그리기 AI</h3>
            <p className="card-description">퀄리티가 낮은 수학 도형 이미지를 고퀄리티로 새로 그려줍니다.</p>
            <p className="card-description">매쓰테일러 전용 그림판을 이용해서 쉽게 보정할 수 있습니다.</p>
          </article>

          <article className="card">
            <span className="badge">무료</span>
            <div className="icon">
              <img src={imgPaint} alt="Paint" />
            </div>
            <h3 className="card-title">수학 도형 전용 그림판</h3>
            <p className="card-description">수학 도형을 쉽고 빠르게 그릴 수 있는 전용 그림판입니다.</p>
            <p className="card-description">배경에 이미지를 추가하여 도형을 쉽고 빠르게 똑같이 그릴 수 있습니다.</p>  
          </article>

        </div>
      </div>
    </section>
  );
};

export default Features;

